exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coupon-message {\n  font-size: 11px;\n  font-weight: 600;\n  color: green;\n}\n.coupon-message.error {\n  font-size: 11px;\n  font-weight: 600;\n  color: red;\n}\n.coupon-container {\n  display: flex;\n  gap: 10px;\n}\n.coupon-container button {\n  background: #4b9fe1;\n  color: #fff;\n  font-size: 12px;\n  border-radius: 8px;\n  padding: 0 2em;\n}", ""]);

// exports
